import React from 'react'
import { Container, Row } from 'react-bootstrap'
import Logo from '../../assets/logos'
import PropTypes from 'prop-types'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import WorkSideNav from './WorkSideNav'
import WorkProjectLinks from './WorkProjectLinks'

const WorkLayout = ({
  pageTitle,
  company,
  slidesLink,
  videoHref,
  date,
  role,
  figmaLink,
  sections,
  children
}) => (
  <div className="work-layout">
    <Header mini />
    <Container>
      <div className="work-layout__body">
        <div className="work-layout__main work-content">
          <header className="work-project-header">
            {company && <Logo className="work-project-header__logo" name={company} />}
            <h1 className="work-project-header__title">{pageTitle}</h1>
            {(date && role) && (
              <p className="work-project-header__meta">{date} | {role}</p>
            )}
          </header>
          <WorkProjectLinks
            slidesLink={slidesLink}
            videoHref={videoHref}
            figmaLink={figmaLink}
            className="work-project-links work-project-links--mobile-only"
          />
          {children}
        </div>
        <WorkSideNav
          sections={sections}
          slidesLink={slidesLink}
          videoHref={videoHref}
          figmaLink={figmaLink}
        />
      </div>
      <Row>
        <Footer />
      </Row>
    </Container>
  </div>
)

WorkLayout.defaultProps = {
  slidesLink: '',
  videoHref: '',
  figmaLink: '',
  company: '',
  sections: [],
  children: null
}

WorkLayout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  company: PropTypes.string,
  slidesLink: PropTypes.string,
  videoHref: PropTypes.string,
  figmaLink: PropTypes.string,
  date: PropTypes.string,
  role: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  children: PropTypes.node
}

export default WorkLayout
